import { Money } from 'src/types';

const defaults: Readonly<Money> = {
  currencyCode: 'GBP',
  amount: '0',
};

export const moneyBuilder = (money?: Partial<Money>): Readonly<Money> => ({
  ...defaults,
  ...money,
});
